import { useCallback, useMemo } from "react";
import { createInitialPriceFilter } from "./usePriceFilterInSearchFilters";

const DEFAULT_FILTER_TITLE_MAP = {
  position: "ポジション",
  price: "金額",
  prefecture: "勤務地",
};

export function useFilterModal({
  isMobile,
  setMenuAnchorEl,
  setFilterDialogOpen,
  setFilterModalOpen,
  setActiveFilter,
  activeFilter,
  executeSearch,
  searchFilters,
  setSearchFilters,
  selectedColor,
  projectColor,
  projectColorDark,
  filterTitleMap,
  scrollToResultsTop,
}) {
  const handleOpen = useCallback(
    (event) => {
      if (isMobile) {
        setMenuAnchorEl((previousAnchorElement) =>
          previousAnchorElement ? null : event.currentTarget
        );
      } else {
        setFilterDialogOpen(true);
      }
    },
    [isMobile, setMenuAnchorEl, setFilterDialogOpen]
  );

  const handleClose = useCallback(() => {
    setFilterDialogOpen(false);
    setFilterModalOpen(false);
  }, [setFilterDialogOpen, setFilterModalOpen]);

  const modalStyle = useMemo(
    () => ({
      position: "absolute",
      top: "50%",
      left: "50%",
      height: "80vh",
      transform: "translate(-50%, -50%)",
      width: "min(956px, calc(100vw - 32px))",
      maxWidth: "956px",
      bgcolor: "background.paper",
      boxShadow: 24,
      p: 7,
      color: selectedColor,
    }),
    [selectedColor]
  );

  const deleteFilter = useCallback(() => {
    setSearchFilters((previousFilters) => {
      const nextFilters = {
        ...previousFilters,
        roleIds: [],
        prefectureIds: [],
        priceFilter: createInitialPriceFilter(),
      };
      scrollToResultsTop?.();
      executeSearch(nextFilters);
      return nextFilters;
    });
  }, [setSearchFilters, executeSearch, scrollToResultsTop]);

  const openFilterModal = useCallback(
    (filterType) => {
      setActiveFilter(filterType);
      setFilterModalOpen(true);
    },
    [setActiveFilter, setFilterModalOpen]
  );

  const resolvedFilterTitleMap = useMemo(
    () => ({ ...DEFAULT_FILTER_TITLE_MAP, ...(filterTitleMap ?? {}) }),
    [filterTitleMap]
  );

  const modalTitle = resolvedFilterTitleMap[activeFilter] ?? "";

  const modalHeaderSx = useMemo(
    () => ({
      display: "flex",
      alignItems: "center",
      bgcolor: "#fff",
      color: selectedColor,
    }),
    [selectedColor]
  );

  const modalFooterOkButtonSx = useMemo(
    () => ({
      bgcolor: projectColor,
      width: { xs: "100%", sm: "auto" },
      "&:hover": { bgcolor: projectColorDark },
    }),
    [projectColor, projectColorDark]
  );

  const handleSubmit = useCallback(() => {
    scrollToResultsTop?.();
    executeSearch(searchFilters);
    handleClose();
  }, [scrollToResultsTop, executeSearch, searchFilters, handleClose]);

  return {
    handleOpen,
    handleClose,
    modalStyle,
    deleteFilter,
    openFilterModal,
    modalTitle,
    modalHeaderSx,
    modalFooterOkButtonSx,
    handleSubmit,
  };
}
